import type { TopElementHeights } from 'contexts';

/** Height of all top elements excluding the global banner itself */
export const otherElementSum = (elements: TopElementHeights) => {
  const { globalBanner, ...otherElements } = elements;
  return Object.values(otherElements).reduce<number>((acc, cv) => {
    const sum = acc + cv;
    return sum;
  }, 0);
};
